export default "__VITE_ASSET__KqAdy25F__"